export default {
  methods: {
    maskField (val, mask) {
      if (val) {
        let str = val.split('')
        let countValue = 0
        let countMask = 0
        for (let i = 0; i < mask.length; i++) {
          if (val.charAt(countValue)) {
            if (mask.charAt(i) === '#') {
              countValue++
              mask = mask.substr(0, i) + str.shift() + mask.substr(i + 1)
            } else {
              countMask++
            }
          } else {
            return mask.substr(0, countMask + countValue)
          }
        }
        return mask
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mask.js